import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material";

@Injectable()
export class SnackBarService {
    constructor(private snackBar: MatSnackBar) { }

    showMessage(message: string, durationInMs = 2000) {
        let config = new MatSnackBarConfig();

        config.horizontalPosition = "right";
        config.duration = durationInMs;

        this.snackBar.open(message, "", config);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/snackbar.service.ts